function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.pageTotalElement = this.querySelector('.slider-counter--total');

    if (!this.slider || !this.sliderControlWrapper) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));

    // dots pagination
    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-button'));
    this.sliderControlLinksArray.forEach(dot => dot.addEventListener('click', this.onButtonClick.bind(this)));

    this.addEventListener('slideChanged', debounce(this.updateHeaderTextColor.bind(this), 500));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    if (this.dataset.section.includes('slideshow')) {
      let { textColor, mobileTextColor } = this.sliderItemsToShow[0].dataset;
      if (this.sliderItemsToShow[0].clientWidth > 800) {
        document.documentElement.style.setProperty('--header-text-color', textColor);
      } else {
        document.documentElement.style.setProperty('--header-text-color', mobileTextColor);
      }
    }

    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    // update pagination on scroll event
    this.sliderControlButtons = this.querySelectorAll('.slider-button');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-button--current');
    });

    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-button--current');
  }

  updateHeaderTextColor(event) {
    if (this.dataset.section.includes('slideshow')) {
      let { textColor, mobileTextColor } = event.detail.currentElement.dataset;
      if (this.slider.clientWidth > 800) {
        document.documentElement.style.setProperty('--header-text-color', textColor);
      } else {
        document.documentElement.style.setProperty('--header-text-color', mobileTextColor);
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });

    let dots = document.querySelectorAll('.slider-button')
    dots.forEach((el) => {
      if (el == event.currentTarget) {
        el.classList.contains('slider-buton--current')
          ? el.classList.remove('slider-button--current')
          : el.classList.add('slider-button--current')
      } else {
        el.classList.remove('slider-button--current')
      }
    })
  }
}

customElements.define('slider-component', SliderComponent);

class CarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Carousel-"]');
    this.sliderItems = this.querySelectorAll('[id^="CarouselSlide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.carousel-counter--current');
    this.sliderControlWrapper = this.querySelector('.carousel-buttons');
    this.sliderDotsWrapper = this.querySelector('.carousel-dots');
    this.pageTotalElement = this.querySelector('.carousel-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.sliderControlWrapper) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    // dots pagination
    this.sliderFirstItemNode = this.slider.querySelector('.carousel__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
    this.sliderControlLinksArray = Array.from(this.sliderDotsWrapper.querySelectorAll('.carousel-dot'));
    this.sliderControlLinksArray.forEach(dot => dot.addEventListener('click', this.onDotClick.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Carousel-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    // update pagination on scroll event
    this.sliderControlButtons = this.querySelectorAll('.carousel-dot');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('carousel-dot--current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('carousel-dot--current');
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();

    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  onDotClick(event) {
    event.preventDefault();

    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });

    let dots = document.querySelectorAll('.carousel-dot')
    dots.forEach((el) => {
      if (el == event.currentTarget) {
        el.classList.contains('carousel-dot--current')
          ? el.classList.remove('carousel-dot--current')
          : el.classList.add('carousel-dot--current')
      } else {
        el.classList.remove('carousel-dot--current')
      }
    })
  }
}

customElements.define('carousel-component', CarouselComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.isComingSoon = this.closest('section[data-section-type="product--coming-soon"]') ? true : false;
  }

  updateColorSwatch() {}

  onVariantChange(event) {
    this.updateOptions(event);
    this.updateMasterId();
    // this.updateKlaviyoItem();
    this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    this.removeErrorMessage();

    if (this.dataset.updateVariantTitle) {
      let variantTitle = this.querySelector('.quickbuy-form__variant-title');
      variantTitle.innerHTML = this.currentVariant.title.replaceAll(' / Regular', '').replaceAll(' / Bundle Item', '').replaceAll(' / Bundle', '');
    }

    if (this.dataset.updateSwatch) {
      this.updateColorSwatch();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateKlaviyoItem() {
    if(_learnq && typeof item != "undefined") {
      // console.log("Variant has changed", this.currentVariant);
      item.Variant = this.currentVariant.title;
      item.Price = Shopify.formatMoney(this.currentVariant.price);
      item.ImageURL = this.currentVariant.featured_image.src;
      if(this.currentVariant.compare_at_price) {
        item.CompareAtPrice = Shopify.formatMoney(this.currentVariant.compare_at_price);
      }
      // console.log("Variant has been pushed", item);
      _learnq.push([ 'track', 'Viewed Product', item ]);
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    let isBundle = this.getVariantData()[0].options.indexOf('Regular') > -1 ? true : false; // Check first variant if contains 'Regular' type option
    this.currentVariant = this.getVariantData().find((variant) => {
      if (isBundle && variant.title.includes('Bundle')) return false;
      return isBundle
        ? variant.options[0] === this.options[0]
        : !variant.options.map((option, index) => { return this.options[index] === option; }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = document.querySelectorAll(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);

    // fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const id = `MediaGallery-${this.dataset.section}`
    //     const html = new DOMParser().parseFromString(responseText, 'text/html')
    //     const destination = document.getElementById(id);
    //     const source = html.getElementById(id);

    //     if (source && destination) destination.innerHTML = source.innerHTML;
    //   });

    if (!newMedia) return;
    newMedia.forEach((media) => {
      const parent = media.parentElement;

      // move variant featured image to top
      parent.prepend(media);

      // make new featured variant image the active image
      media.classList.add('active')
    })

    // updated main image src with new active image (desktop only)
    let newMediaSrc = newMedia[0].getAttribute('data-image-src') || newMedia[0].getAttribute('data-media-src');
    let featuredImage = mediaGallery.querySelector('.product-images__featured img');
    featuredImage.src = newMediaSrc;
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

    if (this.isComingSoon && csItem) {
      let { title, id } = this.currentVariant;
      csItem.ItemVariantName = title.replace(' / Regular', '').replace(' / Bundle Item', '').replace(' / Bundle', '');
      csItem.ItemVariantUrl = csItem.ItemVariantUrl.split('?variant=')[0].concat(`?variant=${id}`);
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        // Update media
        const mediaID = `MediaGallery-${this.dataset.section}`
        const mediaDestination = document.getElementById(mediaID);
        const mediaSource = html.getElementById(mediaID);

        if (mediaSource && mediaDestination) mediaDestination.innerHTML = mediaSource.innerHTML;

        // Update price
        const priceID = `price-${this.dataset.section}`;
        const priceDestination = document.getElementById(priceID);
        const priceSource = html.getElementById(priceID);
        
        if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);


        // Update Ingrediants
        const ingredientSelector = '.product__accordion.accordion';

        const ingredientDestination = document.querySelector(ingredientSelector);
        const ingredientSource = html.querySelector(ingredientSelector);

        if(ingredientSource && ingredientDestination) {
          ingredientDestination.innerHTML = ingredientSource.innerHTML;
        }

      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`) || document.getElementById(`${this.dataset.productFormId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] .product-form__add-button-text');
    
    if (!addButton) return;

    if (disable && this.isComingSoon) {
      document.querySelector('.product__coming-soon').style.display = 'block';
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = window.variantStrings.comingSoon;
      return;
    } else if (!disable && this.isComingSoon) {
      document.querySelector('.product__coming-soon').style.display = 'none';
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] .product-form__add-button-text');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.dataset.updateSwatch = true;
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateColorSwatch() {
    let inputs = document.querySelectorAll('variant-radios input')
    inputs.forEach((el) => {
      let current_title = this.currentVariant.title.replaceAll(' / Regular', '').replaceAll(' / Bundle Item', '').replaceAll(' / Bundle', '');
      if (el.value == current_title) {
        let elSwatch = el.getAttribute('data-swatch')
        document.documentElement.style.setProperty('--accent-swatch', elSwatch)

        let ctaTextColor = el.getAttribute('data-text-color')
        document.documentElement.style.setProperty('--cta-text', ctaTextColor)

        let variantTitle = el.getAttribute('data-title')
        let variantSubtitle = el.getAttribute('data-subtitle')

        let titleContainer = this.nextElementSibling
        titleContainer.querySelector('span').innerHTML = variantTitle
        titleContainer.querySelector('em').innerHTML = variantSubtitle
      }
    });
  }

  togglePreOrderInput(newPreOrderInput){
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const preOrderInput = productForm.querySelector('#preOrder')
    if(newPreOrderInput){
      if(preOrderInput) return;
      productForm.appendChild(newPreOrderInput)
    }else{
      if(!preOrderInput) return;
      productForm.removeChild(preOrderInput)
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true, newBtnPrice) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`) || document.getElementById(`${this.dataset.productFormId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] .product-form__add-button-text');
    const addButtonPrice = productForm.querySelector('[name="add"] .price-wrapper');
    
    if (!addButton) return;

    if (disable && this.isComingSoon) {
      document.querySelector('.product__coming-soon').style.display = 'block';
      addButton.setAttribute('disabled', 'disabled');
      addButtonText.textContent = window.variantStrings.comingSoon;
      return;
    } else if (!disable && this.isComingSoon) {
      document.querySelector('.product__coming-soon').style.display = 'none';
    }

    if(newBtnPrice){
      addButtonPrice.innerHTML = newBtnPrice
    }
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = text;
    }

    if (!modifyClass) return;
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const newProductForm = html.getElementById(`product-form-${this.dataset.section}`);

        // Update media
        const mediaID = `MediaGallery-${this.dataset.section}`
        const mediaDestination = document.getElementById(mediaID);
        const mediaSource = html.getElementById(mediaID);

        if (mediaSource && mediaDestination) mediaDestination.innerHTML = mediaSource.innerHTML;

        // Update price
        const priceID = `price-${this.dataset.section}`;
        const priceDestination = document.getElementById(priceID);
        const priceSource = html.getElementById(priceID);

        // Update button
        document.querySelector(".product-form__submit").innerHTML = html.querySelector(".product-form__submit").innerHTML;
        const newBtnPrice = html.querySelector(".product-form__submit .price-wrapper").innerHTML;
        const addButtonText = newProductForm.querySelector('[name="add"] > span > span');
        
        // Add/Remove Pre-order Input
        const newPreOrderInput = newProductForm.querySelector('#preOrder');       
        this.togglePreOrderInput(newPreOrderInput) 

        if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, addButtonText.textContent, true, newBtnPrice);


        // Update Ingrediants
        const ingredientSelector = '.product__accordion.accordion';

        const ingredientDestination = document.querySelector(ingredientSelector);
        const ingredientSource = html.querySelector(ingredientSelector);

        if(ingredientSource && ingredientDestination) {
          ingredientDestination.innerHTML = ingredientSource.innerHTML;
        }

      });
  }
}

customElements.define('variant-radios', VariantRadios);

class VariantGroupRadios extends VariantSelects {
  constructor() {
    super();

    this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.dataset.updateSwatch = true;
    this.updateOptions();
  }

  getVariantData() {
    const container = this.querySelector('fieldset[data-radio-checked="true"]') || this;
    this.variandData = JSON.parse(container.querySelector(".VG_productVariantsJson").textContent || {});
    return this.variandData;
  }

  updateOptions(event) {
    const target = event?.target || null;
    
    this.options = this.fieldsets.map((fieldset) => {
      let cur_fieldset = null;
      if (target) cur_fieldset = target.closest("fieldset");

      let selected = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      selected = selected ? selected.value : false;
      if (!cur_fieldset) {
        fieldset.dataset.radioChecked = selected ? true : false;
      } else {
        fieldset.dataset.radioChecked = selected && fieldset == cur_fieldset ? true : false;
      }

      return selected;
    });
    this.updateFieldsets();
    this.options = this.options.filter((option) => { return option !== undefined });
  }

  updateFieldsets() {
    this.fieldsets.forEach((fieldset, index) => {
      const hasRadioChecked = fieldset.dataset.radioChecked == "true";
      if (!hasRadioChecked) {
        this.options[index] = undefined;
        fieldset.querySelectorAll("input").forEach((input) => {
          input.checked = false;
          input.removeAttribute("checked")
        });
      }
    });
  }

  updateColorSwatch() {
    let inputs = document.querySelectorAll('variant-group-radios input');
    inputs.forEach((el) => {
      let current_title = this.currentVariant.title.replaceAll(' / Regular', '').replaceAll(' / Bundle Item', '').replaceAll(' / Bundle', '');
      if (el.value == current_title) {
        let elSwatch = el.getAttribute('data-swatch')
        document.documentElement.style.setProperty('--accent-swatch', elSwatch)

        let ctaTextColor = el.getAttribute('data-text-color')
        document.documentElement.style.setProperty('--cta-text', ctaTextColor)

        let variantTitle = el.getAttribute('data-title')
        let variantSubtitle = el.getAttribute('data-subtitle')

        let titleContainer = this.querySelector(".variant-grouping__current-variant");
        titleContainer.innerHTML = `${variantTitle} ${variantSubtitle == "false"
          ? ""
          : "".concat("<em>" + variantSubtitle + "</em>")}`;
      }
    });
  }
}
customElements.define('variant-group-radios', VariantGroupRadios);

// THEME HEADER

// Mobile Menu
class MobileMenu extends HTMLElement {
  constructor() {
    super();
    this.mobileNavEl = document.querySelector('.mobile-nav');
    this.mobileNavToggles = document.querySelectorAll('.mobile-nav-toggle');
    this.mobileNavOverlay = this.mobileNavEl.querySelector('.mobile-nav__overlay');
    this.bindEvents();
  }

  bindEvents() {
    // Toggle mobile menu
    this.mobileNavToggles.forEach((toggle) =>
      toggle.addEventListener('click', this.onMobileNavToggle.bind(this))
    );

    this.mobileNavOverlay.addEventListener('click', this.onMobileNavOverlayClick.bind(this));
  }

  onMobileNavToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('state--nav-open');
  }

  onMobileNavOverlayClick(e) {
    e.preventDefault();
    document.body.classList.remove('state--nav-open');
  }
}

window.customElements.define('mobile-menu', MobileMenu);

// Desktop Menu
class MainMenu extends HTMLElement {
  constructor() {
    super();
    this.headerEl = document.querySelector('.header__main-links');
    this.headerLinks = this.headerEl.querySelectorAll('a');
    this.dropdownLinks = this.headerEl.querySelectorAll('#link-toggle');
    this.dropdownLinkList = this.headerEl.querySelectorAll('.dropdown-link .child-links__inner-lists a')
    this.bindEvents();
  }

  bindEvents() {
    // Disable empty links (with link URL set as '#' in navigation)
    this.headerLinks.forEach(el => {
      if (el.getAttribute('href') == '#') {
        el.addEventListener('click', event => {
          event.preventDefault();
        });
      }
    });

    // Toggle dropdown menu
    this.dropdownLinks.forEach((dropdownEl) =>
      dropdownEl.addEventListener('click', this.onDropdownClick.bind(this))
    );

    // Desktop hover image interactions
    this.dropdownLinkList.forEach(el => {
      el.addEventListener('mouseenter', event => {
        this.setHoverImage(event.target);
      });
    });

  }

  onDropdownClick(e) {
    let dropdownLinkToggles = document.querySelectorAll('#link-toggle')

    dropdownLinkToggles.forEach((el) => {
      if (el == e.currentTarget) {
        el.classList.contains('active')
          ? el.classList.remove('active')
          : el.classList.add('active')
      } else {
        el.classList.remove('active')

      }
    })

    if (e.currentTarget.classList.contains('active')) {
      document.body.classList.add('state--header-active');
    } else {
      document.body.classList.remove('state--header-active');
    }
  }

  setHoverImage(el) {
    const { hoverImage } = el.dataset

    if (hoverImage) {
      const hoverImageEl = this.headerEl.querySelector('#hover-image');

      hoverImageEl.src = hoverImage;
    }
  }
}

window.customElements.define('main-menu', MainMenu);

class HeaderBackground extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("scroll", this.onScroll)
  }

  onScroll() {
    const announcementBarHeight = document.querySelector('#shopify-section-announcement-bar').clientHeight;

    let scrollY = window.pageYOffset || document.documentElement.scrollTop;

    const isScrolled = scrollY > announcementBarHeight;
    document.documentElement.classList.toggle('scrolled', isScrolled);
  }


}

window.customElements.define('header-background', HeaderBackground);

class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.toggleEl = document.querySelector('.toggle-search');
    this.searchDrawer = document.querySelector('.search-drawer');
    this.bindEvents();
  }

  bindEvents() {
    // Toggle dropdown menu
    this.toggleEl.addEventListener('click', this.onSearchClick.bind(this))

  }

  onSearchClick(e) {
    e.preventDefault();
    this.searchDrawer.classList.toggle('active')

    if (this.searchDrawer.classList.contains('active')) {
      document.body.classList.add('state--header-active');
    } else {
      document.body.classList.remove('state--header-active');
    }
  }
}

window.customElements.define('search-drawer', SearchDrawer);

class FooterMenu extends HTMLElement {
  constructor() {
    super();
    this.footerEl = document.querySelector('.footer-links');
    this.dropdownLinks = this.footerEl.querySelectorAll('.dropdown-toggle');
    this.bindEvents();
  }

  bindEvents() {
    // Toggle dropdown menu
    this.dropdownLinks.forEach((dropdownEl) =>
      dropdownEl.addEventListener('click', this.onDropdownClick.bind(this))
    );
  }

  onDropdownClick(e) {
    e.preventDefault();
    let dropdownLinkToggles = document.querySelectorAll('.dropdown-toggle')

    dropdownLinkToggles.forEach((el) => {
      if (el == e.currentTarget) {
        el.parentNode.classList.contains('active')
          ? el.parentNode.classList.remove('active')
          : el.parentNode.classList.add('active')
      } else {
        el.parentNode.classList.remove('active')
      }
    })
  }
}

window.customElements.define('footer-menu', FooterMenu);

class StickyForm extends HTMLElement {
  constructor() {
    super();

    if (!this) return;

    const observeFooter = document.querySelector('footer')

    const handleIntersection = (entries) => {
      if (!entries[0].isIntersecting) {
        this.classList.remove('fade-out')
      } else {
        this.classList.add('fade-out')
      }
    }

    new IntersectionObserver(handleIntersection.bind(observeFooter), {rootMargin: '0px 0px 0px 0px'}).observe(observeFooter);
  }
}

window.customElements.define('sticky-form', StickyForm);
